module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('section', {
    staticClass: "single-doc section_pad"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "single-doc__item-wrap"
  }, [_c('div', {
    staticClass: "box clear_fix hr"
  }, [_c('div', {
    staticClass: "columns small-12 medium-4 large-3"
  }, [_c('div', {
    staticClass: "box__avatar-wrap"
  }, [_c('user-avatar', {
    attrs: {
      "data": _vm.doctor,
      "setClass": 'box__avatar box__avatar_doc-item_single user_fix'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns small-12 medium-8 large-9"
  }, [_c('div', {
    staticClass: "box__content box__content_single box__stars"
  }, [_c('h4', {
    staticClass: "box__title box__title_doc-item underline"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.doctor.last_name) + " " + _vm._s(_vm.doctor.first_name) + " " + _vm._s(_vm.doctor.middle_name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box__labels-wrap"
  }, _vm._l((_vm.doctor.specializations), function(item) {
    return _c('span', {
      staticClass: "box__label"
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), (_vm.doctor.doctor_type) ? _c('div', {
    staticClass: "box__purpose-wrap"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doctor.doctor_type.indexOf('childish') != -1),
      expression: "doctor.doctor_type.indexOf('childish') != -1"
    }],
    staticClass: "box__purpose-item"
  }, [_vm._v("Детский")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doctor.doctor_type.indexOf('adult') != -1),
      expression: "doctor.doctor_type.indexOf('adult') != -1"
    }],
    staticClass: "box__purpose-item"
  }, [_vm._v("Взрослый")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "box__paragraph bold"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.doctor.category) + " " + _vm._s(_vm.doctor.degree) + " " + _vm._s(_vm.doctor.experience) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "box__paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.doctor.description)
    }
  }), _vm._v(" "), _c('rating', {
    attrs: {
      "stars": _vm.doctor.mark,
      "reviewCount": _vm.doctor.mark_count
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 medium-12 large-8 end"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Места приема врача:")]), _vm._v(" "), _vm._l((_vm.doctor.workers), function(worker) {
    return _c('div', {
      staticClass: "box flex clear_fix main-border"
    }, [_c('div', {
      staticClass: "box__avatar-wrap"
    }, [_c('router-link', {
      staticClass: "box__link",
      attrs: {
        "to": {
          name: 'SingleClinic',
          query: {
            id: worker.clinic_id
          }
        }
      }
    }, [_c('user-avatar', {
      attrs: {
        "data": worker,
        "setClass": 'box__avatar box__avatar_clinic fix link_black'
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "box__content box__content_clinic"
    }, [_c('div', {
      staticClass: "box__title box__title_clinic"
    }, [_c('router-link', {
      staticClass: "link_black",
      attrs: {
        "to": {
          name: 'SingleClinic',
          query: {
            id: worker.clinic_id
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(worker.clinic_name) + "\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('p', {
      staticClass: "box__paragraph"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(worker.clinic_city.country.name) + ",\n\t\t\t\t\t\t\t" + _vm._s(worker.clinic_city.region.name) + ",\n\t\t\t\t\t\t\t" + _vm._s(worker.clinic_city.name) + ",\n\t\t\t\t\t\t\tул. " + _vm._s(worker.clinic_street) + ",\n\t\t\t\t\t\t\t" + _vm._s(worker.clinic_house) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('create-visit-button', {
      attrs: {
        "work": worker,
        "appointment": _vm.appointment
      }
    })], 1)
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "map",
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "review-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 medium-12 large-12"
  }, [_c('div', {
    staticClass: "basic-btn review-section__btn"
  }, [(!_vm.isEditor && _vm.logged) ? _c('button', {
    staticClass: "basic-btn__item basic-btn__item_review",
    on: {
      "click": _vm.openEditor
    }
  }, [_vm._v("\n\t\t\t\t\t\tОставить отзыв\n\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), (_vm.isEditor) ? _c('editor', {
    attrs: {
      "whom": "doctor",
      "subject": _vm.doctor
    },
    on: {
      "close": _vm.closeEditor
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reviews-box"
  }, [(_vm.reviews.length) ? _c('h4', {
    staticClass: "reviews-box__title"
  }, [_vm._v("\n\t\t\t\t\tОтзывы о враче \"" + _vm._s(_vm.doctor.last_name) + " " + _vm._s(_vm.doctor.first_name) + " " + _vm._s(_vm.doctor.middle_name) + "\"\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.reviews), function(review) {
    return _c('review', {
      key: review._id,
      attrs: {
        "value": review,
        "whom": "doctor",
        "subject": _vm.doctor
      },
      on: {
        "update": function($event) {
          _vm.getReviews(_vm.doctorID)
        }
      }
    })
  })], 2)], 1)]), _vm._v(" "), _c('appointment')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c64618"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Doctors/SingleDoctor.vue
// module id = 572
// module chunks = 0